import { useMemo } from "react";
import { verifyPermission } from "helpers/permission";

export const useInstitutionPermissions = (userPermissions) => {
  return useMemo(() => {
    return {
      canUpdateInstitution: verifyPermission(
        userPermissions,
        "update-my-institution"
      ),
      canViewInstitution: verifyPermission(
        userPermissions,
        "show-my-institution"
      ),
    };
  }, [userPermissions]);
};
